import React, { useState, useEffect } from 'react';

const IOSInstallPrompt = () => {
  const [showIOSPrompt, setShowIOSPrompt] = useState(false);

  useEffect(() => {
    // Check if it's iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    // Check if it's Safari (PWAs only work with Safari on iOS)
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    // Check if running as standalone app
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || 
                        window.navigator.standalone;

    if (isIOS && isSafari && !isStandalone) {
      setShowIOSPrompt(true);
    }
  }, []);

  if (!showIOSPrompt) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white p-4 shadow-lg border-t border-gray-200 z-50">
      <div className="max-w-md mx-auto">
        <div className="flex items-start mb-2">
          <div className="flex-1">
            <h3 className="text-lg font-semibold">Install Abis CRM</h3>
            <p className="text-sm text-gray-600">
              Install our app on your iPhone:
            </p>
          </div>
          <button 
            onClick={() => setShowIOSPrompt(false)}
            className="text-gray-400 hover:text-gray-500"
          >
            ×
          </button>
        </div>
        <div className="space-y-2 text-sm text-gray-600">
          <div className="flex items-center">
            <span className="mr-2">1.</span>
            <span>Tap the share button</span>
            <svg className="w-5 h-5 ml-1" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2L8 6h3v8h2V6h3L12 2zm3.25 16H8.75a.75.75 0 100 1.5h6.5a.75.75 0 100-1.5z" />
            </svg>
          </div>
          <div className="flex items-center">
            <span className="mr-2">2.</span>
            <span>Scroll down and tap "Add to Home Screen"</span>
          </div>
          <div className="flex items-center">
            <span className="mr-2">3.</span>
            <span>Tap "Add" in the top right</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IOSInstallPrompt;